import { Component } from '@angular/core';
import { RegisterStep1Service } from '@pg-app/auth/services/register-step-1.service';
import { environment } from '@pg-env/environment';
import { LoginInfoService } from '@pg-app/auth/services/login-info.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'np-email-confirmation-error',
  templateUrl: './email-confirmation-error.component.html',
  styleUrls: ['./email-confirmation-error.component.scss']
})
export class EmailConfirmationErrorComponent {
  brandName = environment.brandName;
  email = '';
  sendEmail = false;
  constructor(
    private registerStep1Service: RegisterStep1Service,
    private route: ActivatedRoute
  ) {
    const snapshot = this.route.snapshot;
    this.email = snapshot.params['email'];
  }

  resendEmail() {
    const emailNotArrive = {
      email: this.email,
      clientId: environment.clientId
    };
    this.registerStep1Service.emailNotArrive(emailNotArrive).subscribe(data => {
      this.sendEmail = true;
    });
  }
}
